import { Dialog } from 'alurkerja-ui';
import { OutlineButton } from '@/components/shared/button/OutlineButton';
import { MdCloudDownload } from 'react-icons/md';
import { downloadFile } from '@/utils/libs/fileUtil';
import { TestIssueService } from '@/api/testIssue';
import { ExtendedTableLowCodeRef } from '@/components/shared/table/ExtendedTableLowCode';

type ExportTestIssueProps = {
  id: string;
  projectName?: string;
  tableRef: React.RefObject<ExtendedTableLowCodeRef>;
};

export const ExportTestIssue: React.FC<ExportTestIssueProps> = ({
  id,
  projectName,
  tableRef,
}) => {
  const { mutate: exportMutate, isPending: isExportLoading } =
    TestIssueService.useExport();

  const exportAction = () => {
    const filters = tableRef.current?.getFilter()
    const sort = tableRef.current?.getSort()
    const orderBy = tableRef.current?.getOrderBy()
    exportMutate({ id, filters, sort, orderBy }, {
      onSuccess: response => {
        Dialog.success({
          title: 'Success',
          description: 'Test issue has been exported',
        });

        downloadFile(response, `TestIssues_${projectName}.xlsx`);
      },
      onError: () => {
        Dialog.error({
          title: 'Error',
          description: 'Failed to export test issue',
        });
      },
    });
  };

  return (
    <OutlineButton
      icon={<MdCloudDownload />}
      onClick={exportAction}
      isLoading={isExportLoading}
    >
      Export
    </OutlineButton>
  );
};
